<template>
    <div class="container">
        <v-card>
                <v-card-title>ADMIN. CONFIGURACIÓN MATERIA PRIMA TIPO PRODUCCIÓN</v-card-title>
                <v-card-text>
                    <v-btn color="green" fab small dark @click="crear">
                         <v-icon>add</v-icon>
                    </v-btn>
                </v-card-text>
                <!-- <Tabla :ajustes="this.ajustes" @editar="editar($event)"></Tabla> -->
            </v-card>

            <data-table class="mt-5" @editar="editar($event)"></data-table>

            <modal @peticionrealizada="cargarDatos"></modal>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
// import axios from 'axios'
export default {
    data:()=>({
        lista:[],
        tipos_produccion:[],
        tipos_mps:[],
        inputs:[
            // {tipo:'select_loadable_configurable',valor:'',label:'Seleccione Tipo Producción*',key:'tipo_produccion_id',opciones:[],texto:'tipo_produccion',seleccion:'id',ruta_opciones:'tipo_produccion/opciones/',select_a_cargar:1,texto_opcion:'tipo_materia_prima'},
            {tipo:'select',valor:'',label:'Seleccione Tipo Producción*',key:'tipo_produccion_id',opciones:[],texto:'tipo_produccion',seleccion:'id'},
            {tipo:'select',valor:'',label:'MP Tipo Producción*',key:'tipo_mps_id',opciones:[],texto:'tipo_materia_prima',seleccion:'id'}
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:''
        },
        //configuracion para datatable
        cabeceras:[
                {
                    text: 'Tipo de Producción',
                    align: 'center',
                    sortable: true,
                    value: 'tipo_produccion.tipo_produccion',
                },
                {
                    text: 'Tipo MP',
                    align: 'center',
                    sortable: true,
                    value: 'tipo_mps.tipo_materia_prima',
                },
                { text: 'Acciones', value: 'action', sortable: false, align:'center' },
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true}
        ]
    }),
    mounted() {
        this.cargarDatos();
    },
    methods: {
        async cargarDatos(){
            //this.mostrarLoading('Cargando Datos...');
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}tipo_produccion_mp`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data;
                // Event.$emit('actualizar_lista',this.lista);
                // Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones)
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                //this.mostrarLoading('Cargando Tipos de Producción...');
                this.mostrarLoading({titulo:'Cargando Tipos de Producción...',color:'green'})

                this.cargarTipoProduccion();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },

        async cargarTipoProduccion(){
            let url = `${this.base_url}tipo_produccion`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.tipos_produccion = response.data.data;
                this.inputs[0].opciones = this.tipos_produccion;
                //this.mostrarLoading('Cargando MP Tipos de Producción...');
                this.mostrarLoading({titulo:'Cargando Mp Tipos de Producción...',color:'green'})
                
                this.cargarMPTipoProduccion();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },

        async cargarMPTipoProduccion(){
            let url = `${this.base_url}tipo_produccion_opciones`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.tipos_mps = response.data.data;
                this.inputs[1].opciones = this.tipos_mps;
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        crear(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Crear Configuracion Tipo Mp Producción';
            this.configuracion_modal.boton_submit = 'Crear';
            this.configuracion_modal.ruta = 'tipo_produccion_mp';
            this.configuracion_modal.tipo_peticion = 'POST';
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async editar($event){
            console.log('editando',$event);
            //por cada input se realiza el seteo correspondiente del item que se esta editando
            await this.inputs.forEach(input => {
                //recorrido del objeto a editar
                Object.keys($event).forEach(key => {
                    let valor = $event[key];
                    if(input.key == key){
                        input.valor = valor;
                    }
                });
            });

            let tipo_produccion = await this.$buscarObjeto($event['tipo_produccion_id'],this.tipos_produccion);
            this.inputs[0].valor = tipo_produccion;

            let tipo_mps = await this.$buscarObjeto($event['tipo_mps_id'],this.tipos_mps);
            this.inputs[1].valor = tipo_mps;

            console.log('inputs con datos a editar',this.inputs);
            this.configuracion_modal.titulo_modal = 'Editar Configuracion Tipo Mp Producción';
            this.configuracion_modal.boton_submit = 'Actualizar';
            this.configuracion_modal.ruta = `tipo_produccion_mp/${$event.id}`;
            this.configuracion_modal.tipo_peticion = 'PUT';
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        'modal':Modal,
        'data-table':Data_Table
    }
}
</script>